import { createMMKV } from "react-native-mmkv";

const storage = createMMKV();
export default storage;
